import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactSelect from 'react-select';

import styles from './ContactFormSelect.module.scss';

const ContactFormSelect = ({
  placeholder,
  disabled = false,
  data = null,
  options,
  isSearchable = false,
  handleOnChange,
}) => {
  const { t } = useTranslation('common');
  const [selectedValue, setSelectedValue] = useState(null);
  const [componentIsFocused, setIsFocused] = useState(false);

  const translatedOptions = useMemo(
    () =>
      options.map((option) => ({
        ...option,
        label: option.labelKey ? t(option.labelKey) : option.label,
      })),
    [options, t]
  );

  useEffect(() => {
    if (data) {
      const matchingOption = translatedOptions.find((opt) => opt.value === data || opt.label === data);
      setSelectedValue(matchingOption || { value: data, label: data });
    }
  }, [data, translatedOptions]);

  const handleFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  const customStyles = {
    control: (base) => ({
      ...base,
      border: '1px solid #BFBFBF',
      height: 40,
      paddingLeft: '10px',
      paddingRight: '10px',
      textAlign: 'left',
      boxShadow: 'none',
      '&:hover': { border: '1px solid #BFBFBF' },
    }),
    option: (base, { isFocused }) => ({
      ...base,
      backgroundColor: isFocused ? 'rgba(0, 109, 228, 0.1)' : '#fff',
      color: '#343741',
    }),
    multiValue: () => ({ display: 'none' }),
    valueContainer: (base) => ({
      ...base,
      fontSize: '14px',
      lineHeight: '16px',
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: 'none',
    }),
  };

  return (
    <div className={styles.container}>
      <span className="blocking-span">
        <ReactSelect
          value={selectedValue}
          styles={customStyles}
          className="basic-single"
          classNamePrefix="select"
          placeholder=""
          options={translatedOptions}
          isDisabled={disabled}
          onChange={(option) => handleOnChange(option)}
          onFocus={handleFocus}
          onBlur={handleBlur}
          isSearchable={isSearchable}
        />
        <span className={selectedValue || componentIsFocused ? styles.floatingLabelFocused : styles.floatingLabel}>
          {placeholder}
        </span>
      </span>
    </div>
  );
};

export default ContactFormSelect;
